let configV = {
    URL: 'https://funny-production-1085471920146.asia-southeast1.run.app'
}

export default configV;